import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";

initScrollReveal(targetElements, defaultProps);
initTiltEffect();

// Images
import profile from "./assets/profile.svg";
import favicon from "./assets/favicon.png";
import TP3 from "./assets/TP3.png";
import TP4 from "./assets/TP4.png";
import TP5 from "./assets/TP5.png";
import TP5 from "./assets/TP7.png";


// Favicon 
document.querySelector("#favicon-container").innerHTML = `
  <link href="${favicon}" rel="shortcut icon" type="image/png">
`;

// Profile image
document.querySelector("#profile-container").innerHTML = `
  <img src="${profile}" alt="Profile Image" class="img-fluid rounded shadow-lg" height="auto" width="300px">
`;

// TP3 image in its spot
document.querySelector("#tp3-container").innerHTML = `
  <img src="${TP3}" alt="TP3 Image" class="img-fluid">
`;

// TP4 image in its spot
document.querySelector("#tp4-container").innerHTML = `
  <img src="${TP4}" alt="TP4 Image" class="img-fluid">`
;

// TP5 image in its spot
document.querySelector("#tp5-container").innerHTML = `
  <img src="${TP5}" alt="TP5 Image" class="img-fluid">`
;

// TP7 image in its spot
document.querySelector("#tp7-container").innerHTML = `
  <img src="${TP7}" alt="TP7 Image" class="img-fluid">`
;
